<template>
  <div class="chat-bubble__date">
    {{ formattedDate }}
  </div>
</template>

<script>
import { format, isToday, isYesterday, isThisWeek } from 'date-fns';
import { de } from 'date-fns/locale';

export default {
  name: 'MessageDate',
  props: ['timestamp'],
  data() {
    return {
      formattedDate: '',
    };
  },
  methods: {
    formatDate() {
      const date = new Date(this.timestamp);
      if (isToday(date)) {
        this.formattedDate = `Heute, ${format(date, 'HH:mm')}`;
      } else if (isYesterday(date)) {
        this.formattedDate = `Gestern, ${format(date, 'HH:mm')}`;
      } else if (isThisWeek(date)) {
        this.formattedDate = format(date, 'EEEE, HH:mm', { locale: de });
      } else {
        this.formattedDate = format(date, 'dd. MMM, HH:mm', { locale: de });
      }
    },
  },
  beforeMount() {
    this.formatDate(this.timestamp);
  },
};
</script>
